import { useState } from "react";
import { Delete16Regular } from "@fluentui/react-icons";
import { usePowder } from "../redux/ReduxContext";



export default function OiPowderTags() {
    const { state, dispatch } = usePowder();

    const [newTag, setNewTag] = useState("");



    const handleAddNewTag = () => {
        if (state.tags.some(tag => tag.toLowerCase() === newTag.trim().toLowerCase())) {
            setNewTag("");
            return;
        }
        dispatch({ type: 'ADD_ARRAY_ITEM', payload: { field: 'tags', item: newTag.trim() } });
        setNewTag("");
    };

    const removeTag = (value: string) => {
        const index = state.tags.findIndex(tag => tag.toLowerCase() === value.toLowerCase());
        if (index !== -1) {
            dispatch({
                type: 'DELETE_ARRAY_ITEM',
                payload: {
                    field: 'tags',
                    index: index,
                },
            });
        }
    };

    const handleNewTagKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddNewTag();
        }
    };

    return (
        <div className="bg-white dark:bg-oi-dark-background p-4 mb-4 drop-shadow-md">
            <h6 className="mb-2 text-sm font-bold">Tags</h6>

            <div className="flex gap-2 w-full">
                <div className="relative w-full">
                    <input
                        type="text"
                        placeholder="ie. grain size"
                        value={newTag}
                        onChange={(e) => setNewTag(e.target.value)}
                        onKeyPress={handleNewTagKeyPress}
                        className="h-12 w-full p-2 pr-20 mt-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border bg-primary-light dark:bg-primary-dark border-gray-300 dark:border-gray-600 placeholder-gray-400"
                    />
                    <button
                        className="absolute right-2 top-1/2 -translate-y-1/2 px-3 py-1 bg-oi-button-blue text-primary-light mt-1 h-8 "
                        onClick={handleAddNewTag}
                    >
                        Add
                    </button>
                </div>
            </div>

            <div className="mt-4">
                {state.tags.length === 0 ? (
                    <p className="text-gray-500 text-sm">No tags added yet.</p>
                ) : (
                    <div className="flex flex-wrap gap-3">
                        {state.tags.map((tag, index) => (
                            <label
                                key={index}
                                className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 p-2 rounded transition-colors"
                            >
                                {/* <input
                                    type="checkbox"
                                    checked={tag.isToggled}
                                    onChange={() => handleTagToggle(tag.name, !tag.isToggled)}
                                    className="focus:outline-none h-4 w-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                                /> */}
                                <span className="text-sm text-gray-700 dark:text-gray-300 select-none">
                                    {tag}
                                </span>
                                {tag && (
                                    <button onClick={() => removeTag(tag)}>
                                        <Delete16Regular>

                                        </Delete16Regular>
                                    </button>
                                )}
                            </label>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
